<template>
  <section class="s-info-tabs">
    <div class="s-info-tabs__conts">
      <div class="s-info-tabs__col">
        <div class="s-info-tabs__main">
          <div class="s-info-tabs__title">{{ dictionary.stripTitle }}</div>
          <div class="b-info-tabs">
            <ul class="b-info-tabs__tabs">
              <li v-for="tab in tabs" :key="tab.id">
                <a :href="'#' + tab.id">{{ tab.tabTitle }}</a>
              </li>
            </ul>

            <template v-for="tab in tabs" :key="tab.id">
              <div :id="tab.id" class="b-info-tabs__cont">
              <!--docs-->
                <div v-if="tab.docs" class="s-download-doc">
                  <div class="s-download-doc__conts">
                    <div class="s-download-doc__row">
                      <div class="s-download-doc__main">
                        <h2 class="s-download-doc__head">
                          {{ dictionary.docTitle }}
                        </h2>
                        <div class="s-download-doc__items">
                          <ul>
                            <li
                              v-for="doc in tab.docs"
                              :key="doc.id"
                              @mouseover="lottiePlay(doc)"
                              @mouseleave="lottieStop(doc)">
                              <div class="s-download-doc__lnk">
                                <a :href="doc.url" download>
                                  <h4 class="s-download-doc__title">
                                    {{ doc.title }}
                                  </h4>
                                  <Vue3Lottie
                                    :ref="`lottiePlayer-${doc.id}`"
                                    animation-link="./../../../imgs/lotties/downloadFile.json"
                                    :auto-play="false"
                                    :height="24"
                                    :width="24" />
                                </a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <NetPrice
                  :title="dictionary.netPriceTitle"
                  :lottie-tabs="lottieTabs"
                  :table-data="tab.tableData"
                  :tab-id="tab.id"
                  :chart-handler="tab.chartHandler"></NetPrice>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as lib from './../../lib/lib'
import { Vue3Lottie } from 'vue3-lottie'
import NetPrice from '../components/net-price/NetPrice.vue'

export default {
  components: {
    Vue3Lottie,
    NetPrice,
  },
  data() {
    return {
      tabs: [],
      lottieTabs: [],
      cellLength: 0,
    }
  },

  mounted() {
    const { tabs, lottieTabs } =
      lib.getData('infoTabsDataApp')

    this.tabs = tabs
    this.lottieTabs = lottieTabs

    console.log('enter info', this.tabs)
  },

  methods: {
    lottiePlay(doc) {
      const lottie = this.$refs[`lottiePlayer-${doc.id}`][0]
      lottie.play()
    },

    lottieStop(doc) {
      const lottie = this.$refs[`lottiePlayer-${doc.id}`][0]
      lottie.goToAndStop(0)
    },
  },
  
}
</script>
